import React, { useEffect } from 'react'
import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom'
import PerfectScrollbar from "react-perfect-scrollbar"
import BreadcrumbHeader from '../../../layout/BreadcrumbsHeader'
import { SECONDARY } from '../../../ui-components/CustomButton';
import { Secondary } from '../../../ui-components/Buttons';import { useTheme } from '@emotion/react'
import ThemeBGWrapper from '../../../ui-components/ThemeBGWrapper'
// import { FetchRoundViewDetails, FetchStartupDetails, FetchViewStartupDetails } from '../../../api'
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Box, Card, CircularProgress, Grid, Tab, Tabs, Typography, useMediaQuery, IconButton, Tooltip } from '@mui/material'
import { makeStyles } from "@mui/styles"
import RoundInformation from './RoundInformation'
// import RoundDocuments from './RoundDocuments'

import { ReactComponent as InfoIcon } from '../../../assets/help-circle.svg';
import CustomTabs from '../../../ui-components/CustomTabs'
import { containerRef, handleCopyClick, singleSignOn } from '../../../utils'
import { ContentCopyOutlined, FileCopy, OpenInNew, VpnKey } from '@mui/icons-material'
import NeedHelpButton from 'ui-components/NeedHelpButton'
import RoundDocuments from '../../startups/viewDetails/RoundDocuments'
import StartupInformation from './StartupInformation'
import { FetchRoundViewDetails, FetchViewStartupDetails, GenerateUserTokenByAdminOnly } from 'api/backrr_startups'
import Cookies from 'js-cookie'
import ManageNotes from '../../startups/viewDetails/ManageNotes'
import SubmitFeedback from '../../startups/viewDetails/SubmitFeedback'
import Fundings from '../../startups/viewDetails/Fundings'
import Reports from './Reports'
import Performance from '../../startups/viewDetails/Performance'
import UpdateProfile from '../updateProfile'
import CreateRound from 'views/rounds/CreateRound'
import MatchedInvestors from './MatchedInvestors'
import AdminNotes from './AdminNotes'
import ProgressBar from 'layout/BreadcrumbsHeader/ProgressBar'
import EmailLogs from './EmailLogs'
import { useToast } from 'context/ToastContext'
import { ReactComponent as Subscription } from 'assets/nav_icons/crown-svgrepo-com.svg';
import CreateSubscription from '../popups/CreateSubscription'
import Assessments from './Assessments'
// import RequestedInvestors from './RequestedInvestors'
// import ViewProfile from './ViewProfile'
// import ViewFeedback from './ViewFeedback'
// import RoundInvestorsNew from './RoundInvestorsNew'

const useStyles = makeStyles((theme) => ({
    scrollTabs: {
        '& > .Mui-disabled.MuiTabs-scrollButtons': {
            display: 'none',
            transition: 'all 1s ease'
        }
    }
}));

const ViewDetails = () => {
    // useEffect(() => {
    //     console.log(window.history, 'history')
    //   },[window.history.length])
    const { tab: tabValue } = useParams();
    const theme = useTheme()
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const navigate = useNavigate();
    const isLargeScreen = useMediaQuery(theme.breakpoints.up('md'))
    const classes = useStyles();
    const [count, setCount] = React.useState(0);
    const Actions = ({ percentage = 0, isLoading = false }) => {
        return (
            <>
                {isLoading === false && <ProgressBar progress={{
                    completionPercentage: percentage,
                    isLoading
                }} />}
                <NeedHelpButton />
            </>
        );
    };

    const [searchParams, setSearchParams] = useSearchParams();
    // let tabValue = new URLSearchParams(window.location.search).get("page");
    // console.log("tabl",tabValue)


    const [value, setValue] = React.useState(tabValue ? tabValue : "view-profile");
    // console.log(params,"value", value)


    const handleChange = (event, newValue) => {
        navigate("/backrr_startups/" + newValue, { replace: true });
        setValue(newValue);
    };

    let roundTabs

    const [copied, setCopied] = React.useState(false)

    // const [searchParams, setSearchParams] = useSearchParams();
    let startup_id = searchParams.get("startup_id");
    let cookieStartupId = Cookies.get("startup_id")?.trim();
    // console.log(cookieStartupId, "frgt")
    React.useEffect(() => {
        if (cookieStartupId) {
            if (startup_id?.trim()?.length > 0 && startup_id !== null) {
                Cookies.set("startup_id", startup_id);
            }
            // searchParams.delete("startup_id");
            // setSearchParams(searchParams); // Update the URL without startup_id
        } else if (startup_id?.trim()?.length > 0 && startup_id !== null) {
            Cookies.set("startup_id", startup_id);
            navigate(`/backrr_startups/${value}`, { replace: true });
            // searchParams.delete("startup_id");
            // setSearchParams(searchParams); // Update the URL without startup_id
        } else {
            navigate(-1, {replace: true}); // Navigate back if no valid startup_id
        }
    }, [cookieStartupId, startup_id, setSearchParams, navigate, searchParams]);

    // const startup_id = Cookies.get("startup_id");
    const { data: startupDetails, isLoading: isLoadingStartupDetails, refetch: refetchStartupDetails } = FetchViewStartupDetails(cookieStartupId)
    // console.log(startupDetails, "startupDetails");

    const manage_notes = window.location?.pathname?.includes("backrr_startups") ?
        [{
            label: "Matched Investors",
            // icon: RoundInvestorsIcon,
            value: "matched-investors",
        },
        // {
        //     label: "Requested Investors",
        //     // icon: RoundInvestorsIcon,
        //     value: "requested-investors",
        // },
        {
            label: "Admin Notes",
            // icon: RoundDocumentsIcon,
            value: "admin-notes"
        }] : [{
            label: "Notes",
            value: "view-notes",
        }]

    const round_details_visible = startupDetails?.data?.round_id ? [
        {
            label: "Round Details",
            // icon: RoundInvestorsIcon,
            value: "view-round",
        },
        // {
        //     label: "Documents",
        //     // icon: RoundDocumentsIcon,
        //     value: "view-documents"
        // },
    ] : []
    roundTabs = [
        {
            label: "Profile",
            // icon: RoundDetailsIcon,
            value: "view-profile",
        },
        ...round_details_visible,
        // {
        //     label: "Investors",
        //     icon: RoundInvestorsIcon,
        //     value: "investors",
        // },
        {
            label: "Funding",
            // icon: RoundDocumentsIcon,
            value: "view-funding"
        },
        {
            label: "Reports",
            // icon: RoundDocumentsIcon,
            value: 'view-reports'
        },
        {
            label: "Performance",
            // icon: RoundDocumentsIcon,
            value: "view-performance"
        },
        {
            label: "Assessments",
            // icon: RoundDocumentsIcon,
            value: "assessments"
        },
        {
            label: "Feedback",
            // icon: RoundDocumentsIcon,
            value: "view-feedback"
        },
        {
            label: "Email Logs",
            // icon: RoundDocumentsIcon,
            value: "email-logs"
        },
        ...manage_notes
        // ,
        // {
        //     label: "Investors Documents",
        //     icon: RoundDetailsIcon,
        //     value: "investors_documents"e
        // }
    ]

    const {
        mutateAsync: provideSSOtoAdminAsync,
        status: provideSSOtoAdminStatus,
        error: provideSSOtoAdminError,
        isLoading: isLoadingSSOToken,
        data: provideSSOtoAdminResponse,
    } = GenerateUserTokenByAdminOnly();

    const { addToast } = useToast();
    // const [openCreateSubscription, setOpenCreateSubscription] = React.useState(false);

    // const handleCloseCreateSubs = () => {
    //     setOpenCreateSubscription(false);
    // }

    // const handleOpenCreateSubs = () => {
    //     setOpenCreateSubscription(true);
    // }

    return (
        <>
            {/* <CreateSubscription refetch={refetchStartupDetails} handleClose={handleCloseCreateSubs} open={openCreateSubscription} startup_id={cookieStartupId} startupDetails={startupDetails} /> */}
            {tabValue === "edit" ? <UpdateProfile /> : (tabValue === "edit-round" ? <CreateRound /> :
                <ThemeBGWrapper bgColor={theme.palette.customColors.yellow_bg}>
                    <BreadcrumbHeader title={() => <Box display={"flex"} alignItems={"center"}>
                        <>{
                            isLoadingStartupDetails
                                ? "Loading..."
                                : isSmallScreen
                                    ? "View Details"
                                    : startupDetails?.data?.startup_name
                                        ? startupDetails?.data?.startup_name
                                        : "View Details"
                        } <Tooltip title="View Profile">
                                <IconButton
                                    onClick={() => window.open(startupDetails?.data?.backrr_base_url, '_blank')}
                                >
                                    <OpenInNew sx={{ height: 25 }} />
                                </IconButton>
                            </Tooltip>

                            {startupDetails?.data?.email &&
                                <Tooltip title="Single Sign-On (SSO)">
                                    <IconButton onClick={() => {
                                        if (startupDetails?.data?._id && startupDetails?.data?.email) {
                                            provideSSOtoAdminAsync({ payload: { email: startupDetails?.data?.email } })?.then((response) => {
                                                if (response?.data?.statusCode === 200) {
                                                    window.open(singleSignOn(null, "startup") + "/cHJpdmF0ZS1yb3V0ZQ==?access-token=" + response?.data?.token, "_blank");
                                                }
                                                else {
                                                    addToast("User Not Found", "error")
                                                    // toast.error("User Not Found")
                                                }
                                                // handleCloseMenu(e)
                                            })
                                        }
                                    }}>
                                        <VpnKey fontSize='1.5rem' />
                                    </IconButton>
                                </Tooltip>
                            }

                            {/* <Tooltip title={startupDetails?.data?.subscription?.status === "active" ? "Subscribed" : "Activate Subscription"}>
                                <IconButton
                                    onClick={() => {
                                        handleOpenCreateSubs()
                                    }}
                                    disabled={startupDetails?.data?.subscription?.status === "active"}
                                >
                                    <Subscription fill={startupDetails?.data?.subscription?.status === "active" ? "orange" : "rgba(0, 0, 0, 0.54)"} width={24} height={24} />
                                </IconButton>
                            </Tooltip> */}

                        </></Box>} Actions={(props) => <Actions isLoading={isLoadingStartupDetails} percentage={startupDetails?.data?.profile_progress || 0} {...props} />} sx={{ paddingBottom: 0 }} />
                    {isLoadingStartupDetails ?
                        <Grid item xs={12} height={"100dvh"} sx={{ width: '100%', padding: "2rem", paddingTop: "1rem", bgColor: theme.palette.customColors.yellow_bg }}>
                            {/* <CircularProgress sx={{ color: theme?.palette.customColors.b300 }} /> */}
                            <Box className='skeleton' height={80}>

                            </Box>
                            <Box className='skeleton' height={"calc(100% - 80px)"} marginTop={2}>

                            </Box>
                        </Grid>
                        : <>


                            <Grid xs={12} container bgColor={theme.palette.customColors.yellow_bg} height={"100%"}>
                                <Box sx={{ width: '100%', typography: 'body1' }}>
                                    <TabContext value={value}>
                                        <Box px={isSmallScreen ? "1rem" : "2rem"} bgColor={theme.palette.customColors.yellow_bg}>
                                            <CustomTabs
                                                // data={roundTabs} 
                                                data={
                                                    [...roundTabs?.map(item => {
                                                        return ({ ...item, label: `${item?.label} ${item?.value === value && value === "matched-investors" && count && count !== null ? `(${count})` : ""}` })
                                                    })]
                                                }
                                                value={value} isSmallScreen={isSmallScreen} className={classes} titleStyle={{ fontSize: '1.10rem' }} handleChange={handleChange} key={"Tabs Tabs"} sx={{ paddingTop: '1rem' }} bgColor={theme.palette.customColors.yellow_bg} />
                                        </Box>
                                        <TabPanel value="view-profile" sx={{ paddingInline: 0, height: '100%' }}>
                                            <PerfectScrollbar containerRef={containerRef} style={{ height: isLargeScreen ? "calc(100dvh - 190px)" : "calc(100dvh - 185px)", paddingInline: isSmallScreen ? "1rem" : "2rem" }}>
                                                <StartupInformation data={startupDetails?.data} round_id={"wefrtg"} />
                                            </PerfectScrollbar>
                                        </TabPanel>
                                        {startupDetails?.data?.round_id && <TabPanel value="view-round" sx={{ paddingInline: 0, height: '100%' }}>
                                            <PerfectScrollbar containerRef={containerRef} style={{ height: isLargeScreen ? "calc(100dvh - 190px)" : "calc(100dvh - 185px)", paddingInline: isSmallScreen ? "1rem" : "2rem" }}>
                                                <RoundInformation data={{}} round_id={startupDetails?.data?.round_id} />
                                            </PerfectScrollbar>
                                        </TabPanel>}
                                        {/* {startupDetails?.data?.round_id && <TabPanel value="view-documents" sx={{ paddingInline: 0, height: '100%' }}>
                                        <PerfectScrollbar containerRef={containerRef} style={{ height: isLargeScreen ? "calc(100dvh - 190px)" : "calc(100dvh - 185px)", paddingInline: isSmallScreen ? "1rem" : "2rem" }}>
                                            <RoundDocuments round_id={startupDetails?.data?.round_id} startup_name={startupDetails?.data?.startup_name} />
                                        </PerfectScrollbar>
                                    </TabPanel>} */}
                                        {<TabPanel value="email-logs" sx={{ paddingInline: 0, height: '100%' }}>
                                            <PerfectScrollbar containerRef={containerRef} style={{ height: isLargeScreen ? "calc(100dvh - 190px)" : "calc(100dvh - 185px)", paddingInline: isSmallScreen ? "1rem" : "2rem" }}>
                                                <EmailLogs startup_id={cookieStartupId} />
                                            </PerfectScrollbar>
                                        </TabPanel>}
                                        {/* <TabPanel value="view-notes" sx={{ paddingInline: 0, height: '100%' }}>
                                    <PerfectScrollbar containerRef={containerRef} style={{ height: isLargeScreen ? "calc(100dvh - 190px)" : "calc(100dvh - 185px)", paddingInline: isSmallScreen ? "1rem" : "2rem" }}>
                                        <ManageNotes data={startupDetails?.data} startup_id={cookieStartupId} />
                                    </PerfectScrollbar>
                                </TabPanel> */}
                                        <TabPanel value="view-feedback" sx={{ paddingInline: 0, height: '100%' }}>
                                            <PerfectScrollbar containerRef={containerRef} style={{ height: isLargeScreen ? "calc(100dvh - 190px)" : "calc(100dvh - 185px)", paddingInline: isSmallScreen ? "1rem" : "2rem" }}>
                                                <SubmitFeedback isAdmin={true} />
                                            </PerfectScrollbar>
                                        </TabPanel>
                                        <TabPanel value="view-funding" sx={{ paddingInline: 0, height: '100%' }}>
                                            {/* <PerfectScrollbar containerRef={containerRef} style={{ height: isLargeScreen ? "calc(100dvh - 190px)" : "calc(100dvh - 185px)", paddingInline: isSmallScreen ? "1rem" : "2rem" }}> */}
                                            <Fundings isAdmin={window.location?.pathname?.includes("backrr_startups")} startup_slug={startupDetails?.data?.slug} />
                                            {/* </PerfectScrollbar> */}
                                        </TabPanel>
                                        <TabPanel value="view-reports" sx={{ paddingInline: 0, height: '100%' }}>
                                            {/* <PerfectScrollbar containerRef={containerRef} style={{ height: isLargeScreen ? "calc(100dvh - 190px)" : "calc(100dvh - 185px)", paddingInline: isSmallScreen ? "1rem" : "2rem" }}> */}
                                            <Reports startup_details_id={cookieStartupId} />
                                            {/* </PerfectScrollbar> */}
                                        </TabPanel>
                                        <TabPanel value="view-performance" sx={{ paddingInline: 0, height: '100%' }}>
                                            {/* <PerfectScrollbar containerRef={containerRef} style={{ height: isLargeScreen ? "calc(100dvh - 190px)" : "calc(100dvh - 185px)", paddingInline: isSmallScreen ? "1rem" : "2rem" }}> */}
                                            <Performance startup_id={cookieStartupId} />
                                            {/* </PerfectScrollbar> */}
                                        </TabPanel>
                                        <TabPanel value="assessments" sx={{ paddingInline: 0, height: '100%' }}>
                                            {/* <PerfectScrollbar containerRef={containerRef} style={{ height: isLargeScreen ? "calc(100dvh - 190px)" : "calc(100dvh - 185px)", paddingInline: isSmallScreen ? "1rem" : "2rem" }}> */}
                                            <Assessments startup_id={cookieStartupId} />
                                            {/* </PerfectScrollbar> */}
                                        </TabPanel>
                                        <TabPanel value="matched-investors" sx={{ paddingInline: 0, height: '100%' }}>
                                            <PerfectScrollbar containerRef={containerRef} style={{ height: isLargeScreen ? "calc(100dvh - 190px)" : "calc(100dvh - 185px)", paddingInline: isSmallScreen ? "1rem" : "2rem" }}>
                                                <MatchedInvestors startup_id={cookieStartupId} setCount={setCount} count={count} />
                                            </PerfectScrollbar>
                                        </TabPanel>
                                        {/* <TabPanel value="requested-investors" sx={{ paddingInline: 0, height: '100%' }}>
                                        <PerfectScrollbar containerRef={containerRef} style={{ paddingInline: isSmallScreen ? "1rem" : "2rem" }}>
                                            <RequestedInvestors startup_id={cookieStartupId} setCount={setCount} count={count} />
                                        </PerfectScrollbar>
                                    </TabPanel> */}
                                        <TabPanel value="admin-notes" sx={{ paddingInline: 0, height: '100%' }}>
                                            <PerfectScrollbar containerRef={containerRef} style={{ height: isLargeScreen ? "calc(100dvh - 190px)" : "calc(100dvh - 185px)", paddingInline: isSmallScreen ? "1rem" : "2rem" }}>
                                                <AdminNotes data={startupDetails?.data} startup_id={cookieStartupId} />
                                            </PerfectScrollbar>
                                        </TabPanel>
                                    </TabContext>
                                </Box>
                            </Grid>
                        </>
                    }
                </ThemeBGWrapper>)}
        </>
    )
}

export default ViewDetails